import React, { useContext, useEffect, useState } from 'react'
import styles from './RbExperience.module.css'
import WorkExperienceCard from './WorkExperienceCard'
import { ImCancelCircle } from 'react-icons/im'
import { IoCheckmarkDoneCircleOutline } from 'react-icons/io5'
import { ShimmerThumbnail } from 'react-shimmer-effects'
import { BASE_URL_API } from '../../../References/urls'
import AuthContext from '../../../store/auth-context'
import EditWorkExperience from './EditWorkExperience'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Select from 'react-select'
import { FiSearch, FiMapPin } from 'react-icons/fi'
import { BiAnalyse } from "react-icons/bi";
import { getTotalExperience } from '../../../Helper/helpers'
import RbExperienceAnalyser from './RbExperienceAnalyser'

const RbExperience = (props) => {
    const authCtx = useContext(AuthContext)
    const selectedProfileType = props.selectedProfileType
    const selectedUser = props.selectedUser

    const [addedExperience, setAddedExperience] = useState(null)
    const [fetchingExperiences, setFetchingExperiences] = useState(true)

    const [profileName, setProfileName] = useState('')
    const [institutionName, setInstitutionName] = useState('')
    const [instiAddress, setInstiAddress] = useState('')
    const [workDescription, setWorkDescription] = useState('')
    const [startDate, setStartDate] = useState('')
    const [isCurrentlyWorking, setIsCurrentlyWorking] = useState(true)
    const [endDate, setEndDate] = useState('')
    const [modeOfSalary, setModeOfSalary] = useState('')
    const [currentMonthlySalary, setCurrentMonthlySalary] = useState('')
    const [reasonOfLeaving, setReasonOfLeaving] = useState('')
    const [isValidated, setIsValidated] = useState(false)
    const [formSubmitStatus, setFormSubmitStatus] = useState('NOT_SUBMITTING')

    const [editingExperience, setEditingExperience] = useState(null)
    const [isEditingExperience, setIsEditingExperience] = useState(false)
    const [isAnalyserOpen, setIsAnalyserOpen] = useState(false)

    // Salon search states
    const [salonSearchKey, setSalonSearchKey] = useState('')
    const [selectedCity, setSelectedCity] = useState(null)
    const [selectedState, setSelectedState] = useState(null)
    const [salonSuggestions, setSalonSuggestions] = useState([])
    const [isLoadingSalons, setIsLoadingSalons] = useState(false)
    const [selectedSalon, setSelectedSalon] = useState(null)
    const [showManualEntry, setShowManualEntry] = useState(false)

    // Indian states for filter
    const indianStates = [
        { value: 'Delhi', label: 'Delhi' },
        { value: 'Maharashtra', label: 'Maharashtra' },
        { value: 'Karnataka', label: 'Karnataka' },
        { value: 'Tamil Nadu', label: 'Tamil Nadu' },
        { value: 'Uttar Pradesh', label: 'Uttar Pradesh' },
        { value: 'Gujarat', label: 'Gujarat' },
        { value: 'Rajasthan', label: 'Rajasthan' },
        { value: 'West Bengal', label: 'West Bengal' },
        { value: 'Telangana', label: 'Telangana' },
        { value: 'Haryana', label: 'Haryana' },
        { value: 'Punjab', label: 'Punjab' },
        { value: 'Kerala', label: 'Kerala' },
        { value: 'Madhya Pradesh', label: 'Madhya Pradesh' },
        { value: 'Bihar', label: 'Bihar' },
        { value: 'Andhra Pradesh', label: 'Andhra Pradesh' },
    ]

    // Major cities for filter
    const indianCities = [
        { value: 'Mumbai', label: 'Mumbai' },
        { value: 'Delhi', label: 'Delhi' },
        { value: 'Bangalore', label: 'Bangalore' },
        { value: 'Hyderabad', label: 'Hyderabad' },
        { value: 'Chennai', label: 'Chennai' },
        { value: 'Kolkata', label: 'Kolkata' },
        { value: 'Pune', label: 'Pune' },
        { value: 'Ahmedabad', label: 'Ahmedabad' },
        { value: 'Jaipur', label: 'Jaipur' },
        { value: 'Surat', label: 'Surat' },
        { value: 'Lucknow', label: 'Lucknow' },
        { value: 'Kanpur', label: 'Kanpur' },
        { value: 'Nagpur', label: 'Nagpur' },
        { value: 'Indore', label: 'Indore' },
        { value: 'Thane', label: 'Thane' },
        { value: 'Bhopal', label: 'Bhopal' },
        { value: 'Visakhapatnam', label: 'Visakhapatnam' },
        { value: 'Patna', label: 'Patna' },
        { value: 'Vadodara', label: 'Vadodara' },
        { value: 'Ghaziabad', label: 'Ghaziabad' },
        { value: 'Ludhiana', label: 'Ludhiana' },
        { value: 'Agra', label: 'Agra' },
        { value: 'Nashik', label: 'Nashik' },
        { value: 'Faridabad', label: 'Faridabad' },
        { value: 'Meerut', label: 'Meerut' },
        { value: 'Rajkot', label: 'Rajkot' },
        { value: 'Kalyan-Dombivali', label: 'Kalyan-Dombivali' },
        { value: 'Vasai-Virar', label: 'Vasai-Virar' },
        { value: 'Varanasi', label: 'Varanasi' },
        { value: 'Srinagar', label: 'Srinagar' },
        { value: 'Aurangabad', label: 'Aurangabad' },
        { value: 'Dhanbad', label: 'Dhanbad' },
        { value: 'Amritsar', label: 'Amritsar' },
        { value: 'Navi Mumbai', label: 'Navi Mumbai' },
        { value: 'Allahabad', label: 'Allahabad' },
        { value: 'Ranchi', label: 'Ranchi' },
        { value: 'Howrah', label: 'Howrah' },
        { value: 'Coimbatore', label: 'Coimbatore' },
        { value: 'Jabalpur', label: 'Jabalpur' },
        { value: 'Gwalior', label: 'Gwalior' },
        { value: 'Vijayawada', label: 'Vijayawada' },
        { value: 'Jodhpur', label: 'Jodhpur' },
        { value: 'Madurai', label: 'Madurai' },
        { value: 'Raipur', label: 'Raipur' },
        { value: 'Kota', label: 'Kota' },
        { value: 'Chandigarh', label: 'Chandigarh' },
        { value: 'Guwahati', label: 'Guwahati' },
        { value: 'Noida', label: 'Noida' },
    ]

    useEffect(() => {
        const valid =
            profileName.length > 2 &&
            institutionName.length > 2 &&
            instiAddress.length > 2 &&
            workDescription.length > 2 &&
            modeOfSalary.length > 0
        setIsValidated(valid)
    }, [profileName, institutionName, instiAddress, workDescription, modeOfSalary])

    const getExperiences = async () => {
        setFetchingExperiences(true)
        const response = await fetch(BASE_URL_API + '/addMoreSections', {
            method: 'POST',
            body: JSON.stringify({
                token: authCtx.token,
                stylist_id: selectedUser.stylist_id,
                dataType: 'updated',
                sectionType: 'experience',
            }),
        })
        if (!response.ok) {
            console.log('Something went wrong : server Error!')
        } else {
            const data = await response.json()
            if (data.status === 'success') {
                setAddedExperience(data.response)
            } else {
                if (data.message === 'token Expired, please login again!') {
                    authCtx.logout()
                } else {
                    console.log(data)
                }
            }
        }
        setFetchingExperiences(false)
    }

    useEffect(() => {
        getExperiences()
    }, [selectedUser])

    const getSalonSuggestions = async () => {
        if (!salonSearchKey.trim() && !selectedCity && !selectedState) {
            setSalonSuggestions([])
            return
        }

        setIsLoadingSalons(true)
        try {
            const response = await fetch(BASE_URL_API + '/getSalonForExperienceAdd', {
                method: 'POST',
                body: JSON.stringify({
                    token: authCtx.token,
                    searchKey: salonSearchKey.trim(),
                    city: selectedCity?.value || '',
                    state: selectedState?.value || '',
                }),
            })

            if (!response.ok) {
                console.log('Failed to fetch salons')
                setSalonSuggestions([])
            } else {
                const data = await response.json()
                if (data.status === 'success' && Array.isArray(data.response)) {
                    setSalonSuggestions(data.response)
                } else {
                    setSalonSuggestions([])
                }
            }
        } catch (error) {
            console.error('Error fetching salon suggestions:', error)
            setSalonSuggestions([])
        } finally {
            setIsLoadingSalons(false)
        }
    }

    // Debounced search effect
    useEffect(() => {
        const timer = setTimeout(() => {
            getSalonSuggestions()
        }, 500)

        return () => clearTimeout(timer)
    }, [salonSearchKey, selectedCity, selectedState])

    console.log(authCtx?.userIdentifier)

    const submitFormHandler = async () => {
        setFormSubmitStatus('SUBMITTING')
        const response = await fetch(BASE_URL_API + '/addMoreSections', {
            method: 'POST',
            body: JSON.stringify({
                token: authCtx.token,
                stylist_id: selectedUser.stylist_id,
                executiveIdentifier: authCtx.userIdentifier,
                dataType: 'addNew',
                sectionType: 'experience',
                designation: profileName,
                storeIdentifier: selectedSalon ? selectedSalon.storeIdentifier : '',
                salon_name: institutionName,
                start_date: startDate,
                isCurrentlyWorking: isCurrentlyWorking,
                end_date: endDate,
                address: instiAddress,
                event_description: workDescription,
                monthlySalary: currentMonthlySalary,
                modeOfSalary: modeOfSalary,
                reasonOfLeaving: reasonOfLeaving,
            }),
        })
        if (!response.ok) {
            setFormSubmitStatus('FAILED')
        } else {
            const data = await response.json()
            if (data.status === 'success') {
                getExperiences()
                setFormSubmitStatus('DONE')
            } else {
                setFormSubmitStatus('FAILED')
            }
        }
    }

    const addNewExperienceHandler = () => {
        setFormSubmitStatus('NOT_SUBMITTING')
        setProfileName('')
        setInstitutionName('')
        setInstiAddress('')
        setWorkDescription('')
        setStartDate('')
        setEndDate('')
        setIsCurrentlyWorking(false)
        setModeOfSalary('')
        setCurrentMonthlySalary('')
        setReasonOfLeaving('')
        setSalonSearchKey('')
        setSelectedCity(null)
        setSelectedState(null)
        setSelectedSalon(null)
        setSalonSuggestions([])
        setShowManualEntry(false)
    }

    const handleSalonSelect = (salon) => {
        setSelectedSalon(salon)
        setInstitutionName(salon.storeName)
        setInstiAddress(salon.storeAddress)
        setSalonSearchKey('')
        setSalonSuggestions([])
    }

    const handleManualEntryToggle = () => {
        setShowManualEntry(!showManualEntry)
        if (!showManualEntry) {
            setSelectedSalon(null)
            setInstitutionName('')
            setInstiAddress('')
        }
    }

    const tryAgainHandler = () => {
        setFormSubmitStatus('NOT_SUBMITTING')
    }

    const editExperienceHandler = (k) => {
        setEditingExperience(k)
        setIsEditingExperience(true)
    }

    const editExperienceToggle = () => {
        setIsEditingExperience(!isEditingExperience)
    }

    console.log(getTotalExperience(addedExperience))

    return (
        <div className={styles.mainWrapper}>
            <EditWorkExperience
                item={editingExperience}
                isEditingExperience={isEditingExperience}
                editExperienceToggle={editExperienceToggle}
                getExperiences={getExperiences}
                toast={toast}
            />

            {/* ── LEFT: Experience List ── */}
            <div className={styles.leftWrapper}>
                <div className={styles.headerWrapper}>
                    <span>{selectedProfileType}</span>
                    <span>
                        {/* {getTotalExperience(addedExperience)} years of experience */}
                        <button className={styles.analyserBtn} >
                            <BiAnalyse size={14} onClick={() => setIsAnalyserOpen(true)} />
                        </button>
                    </span>
                    <span className={styles.countBadge}>{addedExperience?.length ?? 0}</span>
                </div>
                {isAnalyserOpen &&
                    <RbExperienceAnalyser data={getTotalExperience(addedExperience)} onClose={() => setIsAnalyserOpen(false)} />
                }
                <div className={styles.bodyWrapper}>
                    {fetchingExperiences ? (
                        <div className={styles.shimmerBlock}>
                            <ShimmerThumbnail height={150} className={styles.containerLoader} />
                            <ShimmerThumbnail height={150} className={styles.containerLoader} />
                            <ShimmerThumbnail height={150} className={styles.containerLoader} />
                        </div>
                    ) : addedExperience !== null && addedExperience.length > 0 ? (
                        <div>
                            {addedExperience.map((item, index) => (
                                <WorkExperienceCard
                                    key={index}
                                    item={item}
                                    editExperienceHandler={editExperienceHandler}
                                />
                            ))}
                        </div>
                    ) : (
                        <div className={styles.emptyState}>No records found!</div>
                    )}
                </div>
            </div>

            {/* ── RIGHT: Add Form ── */}
            <div className={styles.rightWrapper}>

                {formSubmitStatus === 'SUBMITTING' && (
                    <>
                        <div className={styles.rightHeaderWrapper}>Adding experience...</div>
                        <div className={styles.rightBodyWrapper}>
                            <div className={styles.statusScreen}>
                                <img src="https://media.tenor.com/On7kvXhzml4AAAAj/loading-gif.gif" alt="loading" style={{ height: 36 }} />
                                <p>Hold on, adding the experience!</p>
                            </div>
                        </div>
                    </>
                )}

                {formSubmitStatus === 'DONE' && (
                    <>
                        <div className={styles.rightHeaderWrapper}>Experience added!</div>
                        <div className={styles.rightBodyWrapper}>
                            <div className={styles.statusScreen}>
                                <IoCheckmarkDoneCircleOutline size={40} color="#22c55e" />
                                <p>Successfully added!</p>
                                <button className={styles.addNewBtn} onClick={addNewExperienceHandler}>
                                    Add Another
                                </button>
                            </div>
                        </div>
                    </>
                )}

                {formSubmitStatus === 'FAILED' && (
                    <>
                        <div className={styles.rightHeaderWrapper}>Failed!</div>
                        <div className={styles.rightBodyWrapper}>
                            <div className={styles.statusScreen}>
                                <ImCancelCircle size={38} color="#ef4444" />
                                <p>Something went wrong.</p>
                                <button className={styles.addNewBtn} onClick={tryAgainHandler}>
                                    Try Again
                                </button>
                            </div>
                        </div>
                    </>
                )}

                {formSubmitStatus === 'NOT_SUBMITTING' && (
                    <>
                        <div className={styles.rightHeaderWrapper}>
                            Add {selectedProfileType}
                        </div>
                        <div className={styles.rightBodyWrapper}>

                            <div className={styles.eachFieldWrapper}>
                                <div className={styles.fieldTitle}>Designation / Profile</div>
                                <div className={styles.fieldInput}>
                                    <input
                                        placeholder="e.g. Beautician, Manager"
                                        value={profileName}
                                        onChange={(e) => setProfileName(e.target.value)}
                                    />
                                </div>
                            </div>

                            <div className={styles.salonSearchSection}>
                                <div className={styles.searchHeader}>
                                    <div className={styles.searchTitle}>
                                        <FiMapPin size={14} />
                                        Salon / Company Details
                                    </div>
                                    <button
                                        type="button"
                                        className={styles.manualEntryToggle}
                                        onClick={handleManualEntryToggle}
                                    >
                                        {showManualEntry ? 'Search Salon' : 'Manual Entry'}
                                    </button>
                                </div>

                                {!showManualEntry && (
                                    <>
                                        <div className={styles.filterRow}>
                                            <div className={styles.filterItem}>
                                                <Select
                                                    options={indianCities}
                                                    placeholder="Select City"
                                                    isClearable
                                                    value={selectedCity}
                                                    onChange={setSelectedCity}
                                                    styles={{
                                                        control: (base) => ({
                                                            ...base,
                                                            minHeight: '32px',
                                                            fontSize: '12px',
                                                            borderColor: '#e4e7ec',
                                                        }),
                                                        menu: (base) => ({ ...base, fontSize: '12px' }),
                                                    }}
                                                />
                                            </div>
                                            <div className={styles.filterItem}>
                                                <Select
                                                    options={indianStates}
                                                    placeholder="Select State"
                                                    isClearable
                                                    value={selectedState}
                                                    onChange={setSelectedState}
                                                    styles={{
                                                        control: (base) => ({
                                                            ...base,
                                                            minHeight: '32px',
                                                            fontSize: '12px',
                                                            borderColor: '#e4e7ec',
                                                        }),
                                                        menu: (base) => ({ ...base, fontSize: '12px' }),
                                                    }}
                                                />
                                            </div>
                                        </div>

                                        <div className={styles.searchInputWrapper}>
                                            <FiSearch className={styles.searchIcon} size={14} />
                                            <input
                                                type="text"
                                                placeholder="Search salon by name..."
                                                value={salonSearchKey}
                                                onChange={(e) => setSalonSearchKey(e.target.value)}
                                                className={styles.searchInput}
                                            />
                                        </div>

                                        {isLoadingSalons && (
                                            <div className={styles.loadingMessage}>
                                                Searching salons...
                                            </div>
                                        )}

                                        {!isLoadingSalons && salonSuggestions.length > 0 && (
                                            <div className={styles.suggestionsList}>
                                                {salonSuggestions.map((salon, idx) => (
                                                    <button
                                                        key={idx}
                                                        type="button"
                                                        className={styles.suggestionItem}
                                                        onClick={() => handleSalonSelect(salon)}
                                                    >
                                                        <div className={styles.suggestionMain}>
                                                            <span className={styles.suggestionName}>
                                                                {salon.storeName}
                                                            </span>
                                                            {salon.ownerName && (
                                                                <span className={styles.suggestionOwner}>
                                                                    by {salon.ownerName}
                                                                </span>
                                                            )}
                                                        </div>
                                                        <div className={styles.suggestionAddress}>
                                                            <FiMapPin size={11} />
                                                            {salon.storeAddress}
                                                            {salon.city && `, ${salon.city}`}
                                                            {salon.state && `, ${salon.state}`}
                                                        </div>
                                                    </button>
                                                ))}
                                            </div>
                                        )}

                                        {!isLoadingSalons && salonSearchKey && salonSuggestions.length === 0 && (
                                            <div className={styles.noResults}>
                                                No salons found. Try adjusting your search or use manual entry.
                                            </div>
                                        )}

                                        {selectedSalon && (
                                            <div className={styles.selectedSalon}>
                                                <div className={styles.selectedBadge}>Selected</div>
                                                <div className={styles.selectedName}>{selectedSalon.storeName}</div>
                                                <div className={styles.selectedAddress}>{selectedSalon.storeAddress}</div>
                                            </div>
                                        )}
                                    </>
                                )}
                            </div>

                            {(showManualEntry || selectedSalon) && (
                                <>
                                    <div className={styles.eachFieldWrapper}>
                                        <div className={styles.fieldTitle}>Salon / Company Name</div>
                                        <div className={styles.fieldInput}>
                                            <input
                                                placeholder="e.g. Lakme Salon, Naturals"
                                                value={institutionName}
                                                onChange={(e) => setInstitutionName(e.target.value)}
                                                disabled={!showManualEntry && selectedSalon}
                                            />
                                        </div>
                                    </div>

                                    <div className={styles.eachFieldWrapper}>
                                        <div className={styles.fieldTitle}>Address</div>
                                        <div className={styles.fieldInput}>
                                            <input
                                                placeholder="Area, City"
                                                value={instiAddress}
                                                onChange={(e) => setInstiAddress(e.target.value)}
                                                disabled={!showManualEntry && selectedSalon}
                                            />
                                        </div>
                                    </div>
                                </>
                            )}

                            <div className={styles.eachFieldWrapper}>
                                <div className={styles.fieldTitle}>Work Description</div>
                                <div className={styles.fieldInput}>
                                    <textarea
                                        placeholder="What did the candidate do there?"
                                        value={workDescription}
                                        onChange={(e) => setWorkDescription(e.target.value)}
                                        rows={3}
                                    />
                                </div>
                            </div>

                            <div className={styles.eachFieldWrapper}>
                                <div className={styles.fieldTitle}>Start Date</div>
                                <div className={styles.fieldInput}>
                                    <input
                                        type="date"
                                        value={startDate}
                                        onChange={(e) => setStartDate(e.target.value)}
                                    />
                                </div>
                            </div>

                            <div className={styles.eachFieldWrapper}>
                                <div className={styles.fieldTitle}>Currently Working?</div>
                                <div className={styles.fieldInput}>
                                    <button
                                        className={isCurrentlyWorking === false ? styles.optionBtnSelected : styles.optionBtn}
                                        onClick={() => setIsCurrentlyWorking(false)}
                                    >
                                        No
                                    </button>
                                    <button
                                        className={isCurrentlyWorking === true ? styles.optionBtnSelected : styles.optionBtn}
                                        onClick={() => setIsCurrentlyWorking(true)}
                                    >
                                        Yes
                                    </button>
                                </div>
                            </div>

                            {isCurrentlyWorking === false && (
                                <div className={styles.eachFieldWrapper}>
                                    <div className={styles.fieldTitle}>Last Working Date</div>
                                    <div className={styles.fieldInput}>
                                        <input
                                            type="date"
                                            value={endDate}
                                            onChange={(e) => setEndDate(e.target.value)}
                                        />
                                    </div>
                                </div>
                            )}

                            <div className={styles.eachFieldWrapper}>
                                <div className={styles.fieldTitle}>Monthly Salary (₹)</div>
                                <div className={styles.fieldInput}>
                                    <input
                                        type="text"
                                        placeholder="e.g. 12000"
                                        value={currentMonthlySalary}
                                        onChange={(e) => setCurrentMonthlySalary(e.target.value)}
                                    />
                                </div>
                            </div>

                            <div className={styles.eachFieldWrapper}>
                                <div className={styles.fieldTitle}>Salary Mode</div>
                                <div className={styles.fieldInput}>
                                    <button
                                        className={modeOfSalary === 'Cash' ? styles.optionBtnSelected : styles.optionBtn}
                                        onClick={() => setModeOfSalary('Cash')}
                                    >
                                        Cash
                                    </button>
                                    <button
                                        className={modeOfSalary === 'Online' ? styles.optionBtnSelected : styles.optionBtn}
                                        onClick={() => setModeOfSalary('Online')}
                                    >
                                        Online
                                    </button>
                                </div>
                            </div>

                            <div className={styles.eachFieldWrapper}>
                                <div className={styles.fieldTitle}>Reason for Leaving</div>
                                <div className={styles.fieldInput}>
                                    <textarea
                                        placeholder="Why did the candidate leave?"
                                        value={reasonOfLeaving}
                                        onChange={(e) => setReasonOfLeaving(e.target.value)}
                                        rows={2}
                                    />
                                </div>
                            </div>

                        </div>

                        <div className={styles.rightFooterWrapper}>
                            <div className={styles.rightFooterContainer}>
                                <button className={styles.secondaryBtn} onClick={addNewExperienceHandler}>
                                    Cancel
                                </button>
                                {isValidated ? (
                                    <button className={styles.primaryBtn} onClick={submitFormHandler}>
                                        Save
                                    </button>
                                ) : (
                                    <button className={styles.primaryBtnDull} disabled>
                                        Save
                                    </button>
                                )}
                            </div>
                        </div>
                    </>
                )}

            </div>
        </div>
    )
}

export default RbExperience